import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Images
import Icon from '~/common/images/icon-collapse.svg';
import Pencil from '~/common/images/icon-modify-off.svg';
import Pencil2 from '~/common/images/icon-modify-on.svg';

// Import Local Styles
import styles from './dropdown.css';

const Dropdown = ({ children, edit, open, arrow }) => {
    const [visible, setVisible] = useState(open);

    const toggle = (e) => {
        e.preventDefault();
        setVisible(!visible);
    };

    return (
        <div className={`${visible ? styles['dropdown--open'] : ''}`}>
            {arrow ?
                <button className={styles.button} onClick={e => toggle(e)}>
                    <img className={styles.arrow} src={Icon} />
                </button>
                :
                <button className={styles.button} onClick={e => toggle(e)}>
                    {visible ? <img src={Pencil} /> : <img src={Pencil2} />} {edit}
                    <span>Change Plan</span>
                </button>
            }
            <div className={styles.content}>
                {children}
            </div>
        </div>
    );
};

Dropdown.propTypes = {
    children: PropTypes.node
};

export default Dropdown;
